module.exports = __webpack_public_path__ + "static/media/preparing-drink.e517a631.jpg";